document.addEventListener("DOMContentLoaded", function () {
  handleMCContactReviewSlider();
});

function handleMCContactReviewSlider() {
  const mcReviewSlider = document.querySelector(".mc-reviews");

  if (!mcReviewSlider) {
    return;
  }

  const config = {
    slidesPerView: 1,
    spaceBetween: 5,
    autoPlay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    loop: true,
    keyboard: true,
    navigation: {
      nextEl: ".mc-reviews__next",
      prevEl: ".mc-reviews__prev",
    },
    breakpoints: {
      560: {
        spaceBetween: 20,
      },
    },
  };

  new Swiper(mcReviewSlider, { ...config });
}
